/* Biolabs promo: FREE NAD+ Patch Pack over R2,500 (2-8 Nov 2026, SAST).
   Pairs with Shopify automatic discount "FREE NAD+ Patch Pack over R2,500" (BXGY, 100% off 1 patch pack).
   - Shows a progress / unlocked notice in the cart drawer and cart page.
   - Auto-adds 1 patch pack (tagged _bl_promo) once qualifying subtotal >= R2,500; removes it again if the cart drops below.
   - If the shopper removes the auto-added pack, it is not re-added this session (an "Add it free" button is shown instead).
   Safe to delete after 8 Nov 2026. */
(function () {
  'use strict';
  var CFG = {
    variantId: 50055148830962,
    productHandle: 'biolabs-nad-daily-wellness-patches-30-pack',
    threshold: 250000, // cents
    start: Date.parse('2026-11-02T00:00:00+02:00'),
    end: Date.parse('2026-11-08T23:59:59+02:00'),
    prop: '_bl_promo',
    propVal: 'free-nad-patch'
  };
  var now = Date.now();
  var forced = /[?&]bl_promo_test=1/.test(location.search);
  if (!forced && (now < CFG.start || now > CFG.end)) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SS_AUTO = 'blNadAuto', SS_DECL = 'blNadDeclined';
  var busy = false, timer = null, lastCart = null, selfMutating = false;

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function money(c) { return 'R' + Math.ceil(c / 100).toLocaleString('en-US'); }

  function css() {
    if (document.getElementById('bl-nad-css')) return;
    var s = document.createElement('style'); s.id = 'bl-nad-css';
    s.textContent =
      /* 3 Nov 2026 (Liam): same look as the free-delivery bar (.bl-ship): black rounded box, white text, orange highlights + orange bar */
      '.bl-nad{font-family:inherit;border:0;border-radius:10px;background:#0b0b0c;color:#fff;padding:12px 14px;margin:0 0 12px;width:100%;box-sizing:border-box;align-self:stretch;font-size:14px;line-height:1.4}' +
      '.bl-nad__k{display:block;font-family:inherit;font-weight:700;font-size:12px;line-height:1.2;letter-spacing:.06em;text-transform:uppercase;color:#ff7b00;margin:0 0 4px}' +
      '.bl-nad__text{margin:0 0 8px;font-size:14px;color:#fff}.bl-nad__text:last-child{margin-bottom:0}.bl-nad strong{color:#ff7b00}' +
      '.bl-nad__bar{height:6px;border-radius:6px;background:#2a2a2e;overflow:hidden}.bl-nad__bar i{display:block;height:100%;background:linear-gradient(90deg,#ff7b00,#ffb066);border-radius:6px;transition:width .4s ease}' +
      '.bl-nad__btn{margin-top:2px;display:inline-flex;align-items:center;min-height:34px;padding:0 16px;border:0;border-radius:999px;background:#ff7b00;color:#000;font-family:inherit;font-weight:700;font-size:13px;line-height:1;cursor:pointer}' +
      '.bl-nad__btn:hover{background:#ffb066}' +
      '.bl-ship.bl-ship--merged{display:none!important}.bl-nad:has(+.bl-ship--merged){margin-bottom:0!important}';
    document.head.appendChild(s);
  }

  function analyse(cart) {
    var sub = 0, patchLines = [], autoLine = null;
    (cart.items || []).forEach(function (it, idx) {
      if (it.variant_id === CFG.variantId) {
        patchLines.push(it);
        if (it.properties && it.properties[CFG.prop] === CFG.propVal) autoLine = { key: it.key, qty: it.quantity };
      } else {
        sub += (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
      }
    });
    return { sub: sub, hasPatch: patchLines.length > 0, autoLine: autoLine, count: cart.item_count || 0 };
  }

  function getCart() { return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function refreshCartUI() {
    var els = document.querySelectorAll('cart-items-component[data-section-id]');
    if (!els.length) return Promise.resolve();
    return import('@theme/section-renderer').then(function (m) {
      var jobs = [];
      els.forEach(function (el) {
        var id = el.dataset.sectionId; if (!id) return;
        jobs.push(m.sectionRenderer.renderSection(id, { cache: false, mode: el.hasAttribute('data-drawer') ? 'hydration' : 'full' }).catch(function () {}));
      });
      return Promise.all(jobs);
    }).catch(function () { if (/\/cart(\?|$)/.test(location.pathname)) location.reload(); })
      .then(function () { // keep the header bubble in sync
        return getCart().then(function (c) { document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (n) { if (/^\d+$/.test((n.textContent || '').trim())) n.textContent = c.item_count; }); });
      }).catch(function () {});
  }

  function addPatch(manual) {
    busy = true; selfMutating = true;
    var props = {}; props[CFG.prop] = CFG.propVal;
    return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: CFG.variantId, quantity: 1, properties: props }] }) })
      .then(function (r) { if (r.ok) { ss(SS_AUTO, '1'); if (manual) ss(SS_DECL, null); } return r.ok; })
      .then(function () { return refreshCartUI(); })
      .finally(function () { busy = false; setTimeout(function () { selfMutating = false; }, 800); });
  }
  function removeAuto(key) {
    busy = true; selfMutating = true;
    return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () { ss(SS_AUTO, null); return refreshCartUI(); })
      .finally(function () { busy = false; setTimeout(function () { selfMutating = false; }, 800); });
  }

  // 3 Nov 2026 design review: ONE bar for both rewards (free delivery + free NAD+ patch pack share the R2,500 threshold).
  // While this promo runs, the theme's free-delivery bar (.bl-ship) is hidden and this combined bar takes its place.
  function noticeHTML(a) {
    var pct = Math.min(100, Math.round(a.sub / CFG.threshold * 100));
    if (a.sub >= CFG.threshold) {
      if (a.hasPatch) return '<span class="bl-nad__k">// Unlocked &middot; this week only</span><p class="bl-nad__text"><strong>Free delivery</strong> + <strong>FREE NAD+ Patch Pack</strong> in your cart (R0 at checkout).</p><div class="bl-nad__bar" aria-hidden="true"><i style="width:100%"></i></div>';
      return '<span class="bl-nad__k">// Unlocked &middot; this week only</span><p class="bl-nad__text">You have <strong>free delivery</strong> and qualify for a <strong>FREE NAD+ Patch Pack</strong> (30 patches).</p><button type="button" class="bl-nad__btn" data-bl-nad-add>Add it free</button>';
    }
    return '<span class="bl-nad__k">// This week only &middot; ends 8 Nov</span><p class="bl-nad__text">Spend <strong>' + money(CFG.threshold - a.sub) + '</strong> more for <strong>free delivery</strong> + a <strong>FREE NAD+ Patch Pack</strong> (30 patches).</p><div class="bl-nad__bar" aria-hidden="true"><i style="width:' + pct + '%"></i></div>';
  }

  // Slots: directly above the theme's free-delivery bar (.bl-ship) in the drawer and on the cart page;
  // fallback to the top of the drawer summary.
  function slots() {
    var list = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var ship = c.querySelector('.bl-ship');
      if (ship && ship.parentElement) { list.push({ parent: ship.parentElement, before: ship }); return; }
      var t = c.querySelector('.cart-drawer__summary') || c.querySelector('.cart-page__summary .cart-summary');
      if (t) list.push({ parent: t, before: t.firstChild });
    });
    return list;
  }

  function render(a) {
    css();
    var html = a && a.count > 0 ? noticeHTML(a) : '';
    var keep = [];
    slots().forEach(function (sl) {
      var n = sl.before && sl.before.previousElementSibling && sl.before.previousElementSibling.classList.contains('bl-nad') ? sl.before.previousElementSibling : sl.parent.querySelector(':scope > .bl-nad');
      if (!html) return;
      if (!n) { n = document.createElement('div'); n.className = 'bl-nad'; n.setAttribute('role', 'status'); sl.parent.insertBefore(n, sl.before || null); }
      if (n.getAttribute('data-h') !== html) { n.innerHTML = html; n.setAttribute('data-h', html); }
      keep.push(n);
    });
    // merge: hide the separate free-delivery bar while the combined bar is shown
    document.querySelectorAll('.bl-ship').forEach(function (sh) {
      var merged = !!html && !!(sh.previousElementSibling && sh.previousElementSibling.classList.contains('bl-nad'));
      sh.classList.toggle('bl-ship--merged', merged);
    });
    document.querySelectorAll('.bl-nad').forEach(function (n) { if (keep.indexOf(n) < 0) n.remove(); });
  }

  function sync() {
    if (busy) return;
    getCart().then(function (cart) {
      lastCart = cart;
      var a = analyse(cart);
      if (a.sub >= CFG.threshold) {
        if (!a.hasPatch) {
          if (ss(SS_AUTO) === '1') { ss(SS_AUTO, null); ss(SS_DECL, '1'); } // shopper removed our pack
          if (ss(SS_DECL) !== '1') { return addPatch(false).then(sync); }
        }
      } else if (a.autoLine) {
        return removeAuto(a.autoLine.key).then(sync);
      }
      render(a);
    }).catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 450); }

  // Watch cart mutations made by the theme or apps.
  var of = window.fetch;
  if (of && !of.__blNad) {
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)|graphql/.test(url)) p.then(function () { if (!busy) schedule(); }, function () {});
      return p;
    };
    wrapped.__blNad = true; window.fetch = wrapped;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bl-nad-add]');
    if (b) { e.preventDefault(); b.disabled = true; addPatch(true).then(sync); }
  });
  var mo = new MutationObserver(function (muts) {
    if (selfMutating) { if (lastCart) render(analyse(lastCart)); return; }
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.closest && t.closest('.bl-nad')) continue;
      if (t.closest && t.closest('cart-items-component, .cart-drawer__summary, cart-icon, .cart-bubble')) { if (lastCart) render(analyse(lastCart)); schedule(); return; }
    }
  });
  function boot() { mo.observe(document.body, { childList: true, subtree: true }); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
